import { Eye, EyeOff } from "lucide-react";
import { usePro } from "@/contexts/ProContext";
import { useTranslation } from "react-i18next";

export const PrivacyToggle = () => {
  const { privacyMode, setPrivacyMode } = usePro();
  const { t } = useTranslation();
  return (
    <button
      onClick={() => setPrivacyMode(!privacyMode)}
      className="h-9 w-9 rounded-md hover:bg-foreground/5 flex items-center justify-center transition"
      aria-label={privacyMode ? t("privacy.toggle_off") : t("privacy.toggle_on")}
      title={privacyMode ? t("privacy.toggle_off") : t("privacy.toggle_on")}
      data-testid="privacy-toggle-btn"
    >
      {privacyMode
        ? <EyeOff className="h-4 w-4 brand-text" strokeWidth={1.5} />
        : <Eye className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />}
    </button>
  );
};
